import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReconStage from "./ReconStage.jsx";
import FormationStage from "./FormationStage.jsx";
import RaidStage from "./RaidStage.jsx";
import DebriefStage from "./DebriefStage.jsx";
import "./TimeRaid.css";

const STAGES = ["intro", "recon", "formation", "raid", "debrief"];
const STAGE_LABELS = { recon: "Recon", formation: "Formation", raid: "Raid", debrief: "Debrief" };

export default function TimeRaid() {
  const navigate = useNavigate();
  const [stage, setStage] = useState("intro");
  const [reconResult, setReconResult] = useState(null);
  const [formation, setFormation] = useState(null);
  const [raidResult, setRaidResult] = useState(null);

  const restart = () => {
    setReconResult(null);
    setFormation(null);
    setRaidResult(null);
    setStage("intro");
  };

  return (
    <div className="mx-auto max-w-2xl px-4 py-8">
      <button onClick={() => navigate("/")} className="btn-ghost mb-6 !text-[8px]">
        ◀ BACK TO LEVELS
      </button>

      <div className="panel relative overflow-hidden p-6">
        <div className="mb-6">
          <p className="label-pixel text-cyan">Level 02</p>
          <h1 className="pixel-heading text-base text-mist sm:text-xl">Time Raid</h1>
        </div>

        {stage !== "intro" && (
          <div className="mb-6 flex gap-1.5">
            {["recon", "formation", "raid", "debrief"].map((s) => {
              const idx = STAGES.indexOf(s);
              const currentIdx = STAGES.indexOf(stage);
              const complete = idx < currentIdx;
              const active = s === stage;
              return (
                <div key={s} className="flex-1">
                  <div
                    className={`h-1.5 w-full border border-black/60 ${
                      complete ? "bg-lime" : active ? "bg-cyan" : "bg-panel2"
                    }`}
                  />
                  <p
                    className={`mt-1 text-center font-display text-[7px] uppercase ${
                      active ? "text-cyan" : complete ? "text-lime" : "text-mist/30"
                    }`}
                  >
                    {STAGE_LABELS[s]}
                  </p>
                </div>
              );
            })}
          </div>
        )}

        <div className="tr-panel-transition" key={stage}>
          {stage === "intro" && (
            <div className="text-center">
              <p className="mb-3 text-sm text-mist/80">
                Your calendar is under attack — not from one big disaster, but from a hundred
                small things that all feel urgent. Your job as Commander: sort what actually
                matters, build a schedule that protects it, then defend that schedule when the day
                tries to take it back.
              </p>
              <p className="mb-6 text-xs text-mist/50">
                Three phases: classify today's incoming tasks, build a formation around your
                highest-value work, then live through the day defending it.
              </p>
              <button onClick={() => setStage("recon")} className="btn-cyan">
                ▶ START MISSION
              </button>
            </div>
          )}

          {stage === "recon" && (
            <ReconStage
              onComplete={(result) => {
                setReconResult(result);
                setStage("formation");
              }}
            />
          )}

          {stage === "formation" && (
            <FormationStage
              onComplete={(result) => {
                setFormation(result);
                setStage("raid");
              }}
            />
          )}

          {stage === "raid" && formation && (
            <RaidStage
              formation={formation}
              onComplete={(result) => {
                setRaidResult(result);
                setStage("debrief");
              }}
            />
          )}

          {stage === "debrief" && reconResult && formation && raidResult && (
            <DebriefStage
              reconResult={reconResult}
              formation={formation}
              raidResult={raidResult}
              onRetry={restart}
            />
          )}
        </div>
      </div>
    </div>
  );
}
